import * as moment from 'moment';
import {toEndOfWeek, toStartOfWeek} from "../utils/date-utils";

export interface DateRange {
  start: moment.Moment;
  end: moment.Moment;
}

export const createDateRange = (m: moment.Moment): DateRange => {
  return {
    start: toStartOfWeek(m),
    end: toEndOfWeek(m),
  };
}

export const getDateRangeDiffInMillis = (dr: DateRange): number => {
  return dr.end.diff(dr.start);
}


// WEBPACK FOOTER //
// ./src/common/dtos.ts